<script setup lang="ts">
defineProps<{ open: boolean }>();
defineEmits<{ (e: 'close'): void }>();
</script>

<template>
  <Transition
    enter-active-class="transition-opacity duration-200"
    leave-active-class="transition-opacity duration-200"
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
  >
    <div
      v-if="open"
      class="fixed inset-0 z-40 bg-fg/40 lg:hidden"
      data-testid="sidebar-backdrop"
      @click="$emit('close')"
    />
  </Transition>
</template>
